<template>
  <div>
    <v-layout wrap justify-center  class="greyBackground white--text">
      <v-flex xs12 text-center mt-12 pt-8 px-8>
        <h1 style="font-size:2.3em" class="">{{ $t('a') }}</h1>
        <h2 class="secondary--text">{{ $t('b') }}</h2>
      </v-flex>

      <v-flex xs11 sm8 pb-12 mb-8 mt-10>
        <v-layout wrap justify-space-around>
          <v-flex xs12>
            <pricing-selection/>
          </v-flex>
        </v-layout>

        <v-layout wrap mt-6 mb-6 pt-6 pb-6>
          <v-flex xs12 class="text-center white--text">
            <small>
              <div>{{ $t('biggerPlans2') }} <a href="mailto:martin@esnwebservices.com" class="white--text">martin@esnwebservices.com</a></div>
            </small>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center mb-6>
          <v-flex xs12 sm6>
            <pricing-plan/>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>


    <v-layout wrap justify-center align-center pb-12 class="whiteBackground" style="min-height: 115vh">
      <v-flex xs12 sm9 pb-12>
        <v-layout wrap mt-12 mb-12 justify-space-between>
          <v-spacer/>
          <v-flex xs12 sm7 mt-12 pt-12 :class="{'px-12': $vuetify.breakpoint.xs}">
            <h1 class="mt-4" style="font-size:2.5em"><span v-html="$t('k')"/></h1>
            <h2 class="secondary--text mt-6">{{ $t('l') }}</h2>
            <div class="mt-4"><b>{{ $t('m') }}</b></div>
            <div><b>{{ $t('n') }}</b></div>
          </v-flex>
          <v-flex xs12 sm4 text-center pr-12 pt-12>
            <img :src="images.main" :height="$vuetify.breakpoint.xs ? null : '450px'" :width="$vuetify.breakpoint.xs ? '100%' : null" class="mr-12">
          </v-flex>
          <v-spacer/>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center align-center pb-1 class="fullWindowHeight greyBackground white--text">
      <v-flex xs12 sm5 text-center pb-5 :class="{'px-6': $vuetify.breakpoint.xs}">
        <h1 class="secondary--text" style="font-size: 2.5em">{{ $t('o') }}</h1>
        <h1 class="secondary--text">{{ $t('p') }}</h1>
        <div class="my-12" style="font-size: 1.25em"><b>{{ $t('q') }}<br>{{ $t('r') }}</b></div>
        <v-btn :to="'/book-demo' + langParamStr" class="secondary">{{ $t('s') }}</v-btn>
      </v-flex>
    </v-layout>

    <v-layout wrap class="greyBackground pb-1 white--text">
      <v-spacer/>
      <v-flex xs5>
        <div><small>{{ $t('footer1') }}</small></div>
      </v-flex>
      <v-flex xs5 text-end>
        <div>
          <small>
            <a href="mailto:martin@esnwebservices.com" class="white--text">martin@esnwebservices.com</a>
            <span>{{ $t('footer2a') }}</span>
            <a target="_blank" class="white--text" href="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FCGU%20ESN%20Web%20Services.pdf?alt=media&token=e888057c-0e79-4bd7-bdbd-05afc66c13f9">{{ $t('footer2b') }}</a>
          </small>
        </div>
      </v-flex>
      <v-spacer/>
    </v-layout>
  </div>
</template>

<script>
import PricingSelection from '@/components/PricingSelection'
import PricingPlan from '@/components/PricingPlan.vue'

export default {
  components: {
    PricingSelection,
    PricingPlan
  },
  computed: {
    langParamStr() {
      const lang = this.$route.query.lang
      if (lang && lang !== 'fr') {
        return `?lang=${lang}`
      }
      return ''
    },
  },
  data: () => ({
    images: {
      main: require('@/assets/app/images/businessman__flatline.svg'),
    },
    isShowingYearly: false
  }),
}
</script>

<style scoped>
  .switch-center {
    display: flex;
    justify-content: center;
  }
</style>

<i18n>
{
  "fr": {
    "a": "Des formules pour toutes les ESN",
    "b": "Combien de dossiers de compétences créez-vous chaque mois ?",
    "c": "Le plus choisi",
    "d": "€/mois",
    "e": "dossiers",
    "f": "de compétences",
    "g": "générés par mois",
    "h": "Sur-mesure",
    "i": "Nous disposons d'offres spécialement conçues pour équiper les grandes ESN.",
    "j": "Contactez-nous à",
    "k": "Nos abonnements mensuels sont<br>sans engagement et flexibles.",
    "l": "Vous avez temporairement besoin de plus de dossiers suite à un appel d'offres ?",
    "m": "Passez à l'abonnement supérieur, puis redescendez au mois suivant.",
    "n": "En deux clics c'est fait.",
    "o": "Essayez gratuitement",
    "p": "Choisissez votre formule plus tard",
    "q": "Découvrez notre IA avec",
    "r": "10 dossiers de compétences gratuits",
    "s": "Tester gratuitement",
    "10": "Mensuel",
    "11": "Annuel",
    "discount": "Économisez 1 mois",
    "biggerPlans1": "Nous disposerons bientôt d'offres spécialement conçues pour équiper les plus petites ESN.",
    "biggerPlans2": "Discutez avec un commercial à",

    "footer1": "ESN Web Services © 2023 • Tous droits réservés.",
    "footer2a": " • ",
    "footer2b": "Conditions Générales d'Utilisation"
  },
  "en": {
    "a": "Plans that work at any scale",
    "b": "How many CVs do you transform each month ?",
    "c": "Most popular",
    "d": "€/month",
    "e": "CVs",
    "f": "per month",
    "g": " ",
    "h": "Enterprise",
    "i": "We have bigger plans<br>for bigger companies.",
    "j": "Contact us at",
    "k": "Change your monthly subscription at any time.",
    "l": "You have a peak activity and temporarily need more CVs ?",
    "m": "Upgrade your subscription, and downgrade it back for the next month.",
    "n": "Done in two clics.",
    "o": "Try for free",
    "p": "Choose your subscription later",
    "q": "Test our solution with a",
    "r": "10 CVs-free trial ",
    "s": "Get free trial",
    "10": "Monthly",
    "11": "Yearly",
    "discount": "Save 1 month yearly",
    "biggerPlans1": "We have bigger plans for bigger companies.",
    "biggerPlans2": "Contact sales at",

    "footer1": "ESN Web Services © 2023 • All rights reserved.",
    "footer2a": " • ",
    "footer2b": "Terms of service"
  }
}
</i18n>